import { isDefined, isNotDefined } from '@sgme/fp';
import type { Correlation, CorrelationsMap } from 'state/quotes/correlations/correlations.model';
import { AppState } from 'state/state.model';
import { LoadableResult } from 'utils/status';
export function getCorrelationsByTabId(state: AppState, tabId: string | undefined) {
  return getCorrelation(state.quotes.correlations, tabId);
}

export function getCorrelation(state: CorrelationsMap, tabId: string | undefined): Correlation | undefined {
  return tabId ? state[tabId] : undefined;
}

export function getCorrelationSaveInfo(state: AppState, tabId: string): LoadableResult | undefined {
  return getCorrelationsByTabId(state, tabId)?.saveCorrelation;
}

export function hasAtLeastOnCorrelationParam(state: AppState, tabId: string | undefined): boolean {
  const correlation = getCorrelationsByTabId(state, tabId);
  if (isNotDefined(correlation)) {
    return false;
  }
  const { correlCarry: _, ...correlationFieldsValues } = correlation;
  return Object.values(correlationFieldsValues).some(v => isDefined(v));
}
